<script>
export default {
    name: 'IconAddress',
}
</script>
<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg"
        class="base-icon icon-address"
        viewBox="0 0 64 64"
    >
            <path 
                fill="currentColor" 
                fill-rule="evenodd" 
                d="M32 64 13.615 45.255A26.675 26.675 0 0 1 6.5 31.68a26.995 26.995 0 0 1 1.48-15.316 26.406 26.406 0 0 1 9.575-11.897A25.645 25.645 0 0 1 32 0c5.142 0 10.17 1.555 14.445 4.468a26.407 26.407 0 0 1 9.576 11.897A26.992 26.992 0 0 1 57.5 31.68a26.674 26.674 0 0 1-7.116 13.574L32 64Zm14.3-22.91a20.744 20.744 0 0 0 5.534-10.557c.78-4 .38-8.146-1.151-11.913a20.538 20.538 0 0 0-7.448-9.253A19.947 19.947 0 0 0 32 5.892c-4 0-7.91 1.21-11.235 3.475a20.538 20.538 0 0 0-7.448 9.253 20.993 20.993 0 0 0-1.15 11.913c.78 4 2.705 7.673 5.533 10.557L32 55.67l14.3-14.58ZM32 32.4a5.722 5.722 0 0 1-4.085-1.725 5.95 5.95 0 0 1-1.693-4.166 5.95 5.95 0 0 1 1.692-4.165A5.722 5.722 0 0 1 32 20.618c1.532 0 3.002.621 4.085 1.726a5.95 5.95 0 0 1 1.693 4.165 5.95 5.95 0 0 1-1.693 4.166A5.721 5.721 0 0 1 32 32.401Z" 
            />
    </svg>
</template>